module.exports = __webpack_public_path__ + "static/media/snehashis.d90eb613.jpg";